import ButtonFooter from './ButtonFooter';

export default ButtonFooter;
